import { Button } from './ui/button';
import { Plus } from 'lucide-react';

interface ReportButtonProps {
  onClick: () => void;
}

export default function ReportButton({ onClick }: ReportButtonProps) {
  return (
    <Button
      onClick={onClick}
      size="lg"
      className="fixed bottom-6 right-6 z-50 bg-gray-900 hover:bg-gray-800 text-white shadow-xl hover:shadow-2xl transition-all duration-200 gap-2 rounded-full border-0 lg:px-6 w-16 h-16 lg:w-auto lg:h-auto p-0 lg:p-3"
    >
      <Plus className="w-12 h-12 lg:w-6 lg:h-6" strokeWidth={2.5} />
      <span className="hidden lg:inline">Signaler</span>
    </Button>
  );
}